var $ = (window.jQuery = require("jquery"));
var featherlight = require("./featherlight.js");
var fitvids = require("fitvids");
var objectFitImages = require("object-fit-images");
var jQueryBridget = require("jquery-bridget");
var Flickity = require("flickity");
var asNavFor = require("flickity-as-nav-for");
var matchHeight = require("jquery-match-height");

require("flickity-imagesloaded");
Flickity.setJQuery($);
jQueryBridget("flickity", Flickity, $);

$(document).ready(function () {
    $("iframe").wrap("<div class='resp-container'/>");

    $(".primary-nav__toggle a").on("click", function (e) {
        $(".page-section--site-header").toggleClass("show-nav");
        e.preventDefault();
    });

    heroAnimation();
    initVideoCarousel();
    objectFitImages();
    initStoryModal();
    storyTitleBanner();
    checkWindowSizeMobileMenu();
    initAttractionsListing();
    wrapFormSelects();
    wrapTables();
    initCarousel();
    vehicleListingCarousel();

    $('.card--basic').matchHeight({
        byRow: false,
    })
});

$(window).on("scroll", function () {
    if (window.matchMedia("(max-width: 767px)").matches && $('.site-header').hasClass('show-nav') && $(window).scrollTop() > $('.site-header__primary-nav').height()) {
        $('.site-header.show-nav').removeClass('show-nav');
        $('.sub-menu').each(function () {
            $(this).attr('style', '');
            $(this).parent().removeClass('active');
        })
    }
});
$(window).on("resize", function () {
    checkWindowSizeMobileMenu();
    calcModalHeight();

    // removes open lightbox modal
    if (window.matchMedia("(min-width: 992px)").matches) {
        if ($(".featherlight").length) {
            $(".featherlight .story__modal-exit").trigger("click");
            $(".featherlight .closecommunities-listing__modal-close").trigger(
                "click"
            );
            $(".stories-list__story.active").removeClass("active");
        }
    }
});

(function (jQuery) {
    jQuery(document).on('facetwp-refresh', function () {

        if (typeof FWP.facets['attraction_types'] !== 'undefined' && FWP.facets['attraction_types'].length > 0) {
            $('.community-attractions-listing__clear-fitlers').removeClass('disable');
        } else {
            $('.community-attractions-listing__clear-fitlers').addClass('disable');
        }
    })
    jQuery(document).on('facetwp-loaded', function () {
        jQuery('.community-attractions-listing__attraction').matchHeight({
            byRow: false,
        });
    });
})(jQuery);

// fitvids
fitvids(".basic-content iframe");

// waypoints
require("waypoints/lib/jquery.waypoints");

var waypoints = $(".connected-sections__row").waypoint(
    function (direction) {
        $(this[(0, "element")]).addClass("triggered");
    }, {
        offset: "25%",
    }
);

function heroAnimation() {
    $(".intro-content .intro-content__wysiwyg-content").addClass("fade-in");
    $(".intro-content__hero-visual-section").addClass("animate-in");
}

function checkWindowSizeMobileMenu() {
    //if window is > 767, hide mobile menu
    if ($(window).width() > 768) {
        $("#menu-primary-navigation li").off("click");
        // $('.sub-menu').attr('style', '');
        // $("#menu-primary-navigation li ul")
        //     .hide()
        //     .removeClass("fallback");
        $("#menu-primary-navigation .menu-item-has-children").hover(
            function () {
                let height = $(this).children('.sub-menu')[0].scrollHeight;
                $(this).children('.sub-menu').addClass('active');
                $(this).children('.sub-menu').css('max-height', height);
                if ($(this).closest('.sub-menu').length) {
                    let parentMaxHeight = $(this).closest('.sub-menu').css('max-height');
                    $(this).closest('.sub-menu').css('max-height', parseInt(parentMaxHeight) + height);
                }
            },
            function () {
                let height = $(this).children('.sub-menu')[0].scrollHeight;
                $(this).children('.sub-menu').css('max-height', 0);

                if ($(this).closest('.sub-menu').length) {
                    let parentMaxHeight = $(this).closest('.sub-menu').css('max-height');
                    $(this).closest('.sub-menu').css('max-height', parseInt(parentMaxHeight) - height);
                }

                $(this).children('.sub-menu').removeClass('active');

                setTimeout(() => {}, 400);
            }
        );
    } else {
        $("#menu-primary-navigation li").off("mouseenter mouseleave");
        $('.sub-menu').attr('style', '');
        $("#menu-primary-navigation .menu-item-has-children").on('click', function (e) {
            e.stopPropagation();
            $(this).toggleClass('active');
            if ($(this).hasClass('active')) {
                // $(this).children('.sub-menu')
                //     .stop()
                //     .slideDown(100);
                let height = $(this).children('.sub-menu')[0].scrollHeight;
                $(this).children('.sub-menu').css('max-height', height);
                if ($(this).closest('.sub-menu').length) {
                    let parentMaxHeight = $(this).closest('.sub-menu').css('max-height');
                    $(this).closest('.sub-menu').css('max-height', parseInt(parentMaxHeight) + height);
                }
            } else {
                // $(this).children('.sub-menu')
                //     .stop()
                //     .slideUp(100);
                $(this).children('.sub-menu').css('max-height', 0);
            }
        });

    }
}

function storyTitleBanner() {
    let siblings = $(".story__banner.more-height")
        .parent()
        .siblings();

    siblings.each(function () {
        $(this)
            .find(".story__banner")
            .addClass("more-height");
    });
}

// story modals

function initStoryModal() {
    let modal;
    let mediaQuery = window.matchMedia("(min-width: 992px)");

    function toggleModal() {
        $(".story__modal").remove();
        $(".stories-list__story.active").removeClass("active");
        $(".story__banner.active").removeClass("active");
        $(this).addClass("active");
        $(this)
            .find(".story__banner")
            .addClass("active");

        createModal($(this));

        let modalHeight = $(".story__modal-container")[0].scrollHeight + 30;
        var $content = modal.toString();

        // if window is bigger than 991 display modal as a shelf
        if (mediaQuery.matches) {
            $("html").removeClass("with-featherlight");
            $(".story__modal").css({
                "max-height": modalHeight,
            });
            $("html, body").animate({
                    scrollTop: $(".story__modal").offset().top - 100,
                },
                500
            );

            // if less than display as lightbox
        } else {
            $.featherlight($content, {
                otherClose: ".story__modal-exit",

                //runs before lightbox opens. doesnt allow lightbox to open if > 991
                beforeOpen: function (event) {
                    if (mediaQuery.matches) {
                        $("html").removeClass("with-featherlight");
                        return false;
                    }
                },

                //runs before lightbox close
                beforeCLose: function (event) {
                    if (mediaQuery.matches) {
                        $("html").removeClass("with-featherlight");
                        return false;
                    }
                },
            });
        }
    }

    function createModal(ele) {
        let parent = ele.parent(".stories-list-wrapper__row");
        let driverInfo = ele.find(".story__person-info p").html();
        let quote = ele.find(".story__modal-info-quote").text();
        let vehiclePicture = ele.find(".story__modal-car-image").attr("src");
        let vehicleLink = ele.find(".story__modal-car-link");
        let additionalContent = ele
            .find(".story__modal-additional-content--container")
            .html();
        let ctaLink = ele.find(".story__modal-cta");
        let color = ele.data("tile-color");
        let icon = ele.find(".cta-icon").attr("src");
        let vehicleLinkStr = "";
        if (vehicleLink.attr("href") != "") {
            vehicleLinkStr =
                '<a href="' +
                vehicleLink.attr("href") +
                '" target="_blank">' +
                vehicleLink.text() +
                "</a>";
        } else {
            vehicleLinkStr =
                '<p class="car-info__car">' + vehicleLink.text() + "</p>";
        }

        let car = '',
            linkText, linkUrl;

        if (vehiclePicture) {
            car = `<div class="car">
                    <div class="car-image">
                        <img src="${vehiclePicture}" alt="">
                    </div>
                    <div class="car-info">
                        <p class="car-info__title">my car</p>
                        ${vehicleLinkStr}
                    </div>
                </div>`;

            linkText = 'Find your EV';
            linkUrl = '/explore-electric-cars/';
        } else {
            linkText = ele.find('.story__modal-info .button').text();
            linkUrl = ele.find('.story__modal-info .button').attr('href');
        }

        modal = `
        <div class="story__modal">
            <div class="story__modal-container">
                <div class="story__modal-exit">
                    <i class="fal fa-times"></i>
                </div>
                <div class="story__modal-content-container">
                    <p class="story__modal-name">${driverInfo}</p>
                    <div class="story__modal-left-container ${ !additionalContent ? `without-additional-content` : ``}">
                        <p class="story__modal-quote">${quote}</p>
                        <div class="story__modal-car-container">
                            ${car}
                            <a class="button" href="${linkUrl}">${linkText}</a>
                        </div>
                    </div>
                    ${ additionalContent ? `<div class="story__modal-right-container">
                                                ${additionalContent}
                                            </div>` : `` }
                </div>
                <div class="story__modal-cta" style="background-color:rgb(${color});">
                    ${ icon ? `<div class="story__modal-cta-icon">
                                    <img src="${icon}" alt="">
                                </div>` : ``
                    }
                    ${ ctaLink.length ? `<a href="${ctaLink.attr("href")}" target="_blank">${ctaLink.text()}</a>` : '' }
                </div>
            </div>
        </div`;

        // desktop append modal to parent content, mobile on body
        if (mediaQuery.matches) {
            parent.append(modal);
        } else {
            $("body").append(modal);
        }

        $(".story__modal-exit").on("click", function () {
            $(".story__modal").css("max-height", 0);
            setTimeout(function () {
                $(".story__modal").remove();
                $(".stories-list__story.active").removeClass("active");
                $("html, body").animate({
                        scrollTop: $(".story__banner.active").offset().top - 275,
                    },
                    500
                );
                $(".story__banner.active").removeClass("active");
            }, 200);
        });
    }

    // add click events to story tiles
    $(".stories-list__story").on("click", toggleModal);
}

function calcModalHeight() {
    let mediaQuery = window.matchMedia("(min-width: 992px)");
    if ($(".story__modal").length) {
        let height = $(".story__modal")[0].scrollHeight + 30;
        if (mediaQuery.matches) {
            $(".story__modal").css("max-height", height);
        }
    }
}

// Destination Electric State Blocks

var $clonedContainer;
$(".state-block").on("click", function (e) {
    let mediaQuery = window.matchMedia("(min-width: 992px)");
    // $('.cloned-container .expander-section').remove();

    var $expandContent = $(this).find(".expander-section");
    var $parentContainer = $(this).parent();
    $clonedContainer = $parentContainer.find(".cloned-container");
    $(".state-block").removeClass("active");
    $(this).addClass("active");

    $(".cloned-container").empty();

    if (mediaQuery.matches) {
        $expandContent.clone().appendTo($clonedContainer);

        $clonedContainer.find(".expander-section").slideDown();

        $([document.documentElement, document.body]).animate({
                scrollTop: $($clonedContainer).offset().top - 20,
            },
            500
        );
        e.preventDefault();
    } else {
        $(".state-block.active").removeClass("active");
        $.featherlight($expandContent, {
            otherClose: ".close-state-blocks",

            //runs before lightbox opens. doesnt allow lightbox to open if > 991
            beforeOpen: function (event) {
                if (mediaQuery.matches) {
                    $("html").removeClass("with-featherlight");
                    return false;
                }
            },

            //runs before lightbox close
            beforeCLose: function (event) {
                if (mediaQuery.matches) {
                    $("html").removeClass("with-featherlight");
                    return false;
                }
            },
        });
    }
});

$(document).on("click", ".close-state-blocks", function () {
    $(".cloned-container").empty();
    $(".state-block").removeClass("active");

    $([document.documentElement, document.body]).animate({
            scrollTop: $(".page-section--state-blocks").offset().top,
        },
        500
    );
});

// Community listings

$(".communities-listing__state-block")
    .not(".communities-listing__state-block--link")
    .on("click", function (e) {
        let mediaQuery = window.matchMedia("(min-width: 992px)");
        // $('.cloned-container .expander-section').remove();

        var $expandContent = $(this).find(".communities-listing__state-modal");
        var $parentContainer = $(this).parent();
        $clonedContainer = $parentContainer.find(
            ".communities-listing__cloned-container"
        );
        $(".communities-listing__state-block").removeClass("active");
        $(this).addClass("active");

        $(".communities-listing__cloned-container").empty();

        if (mediaQuery.matches) {
            $expandContent.clone().appendTo($clonedContainer);

            $clonedContainer
                .find(".communities-listing__state-modal")
                .slideDown();

            $([document.documentElement, document.body]).animate({
                    scrollTop: $($clonedContainer).offset().top - 20,
                },
                500
            );
            e.preventDefault();
        } else {
            $(".communities-listing__state-block.active").removeClass("active");
            $.featherlight($expandContent, {
                otherClose: ".communities-listing__modal-close",

                //runs before lightbox opens. doesnt allow lightbox to open if > 991
                beforeOpen: function (event) {
                    if (mediaQuery.matches) {
                        $("html").removeClass("with-featherlight");
                        return false;
                    }
                },

                //runs before lightbox close
                beforeCLose: function (event) {
                    if (mediaQuery.matches) {
                        $("html").removeClass("with-featherlight");
                        return false;
                    }
                },
            });
        }
    });

$(document).on("click", ".communities-listing__modal-close", function () {
    let parentRow = $(this).parents(".communities-listing__states-row");
    $(".communities-listing__cloned-container").empty();
    $(".communities-listing__state-block").removeClass("active");

    $([document.documentElement, document.body]).animate({
            scrollTop: parentRow.offset().top,
        },
        500
    );
});

// vehicle listing

var jQueryBridget = require("jquery-bridget");
var Isotope = require("isotope-layout");
jQueryBridget("isotope", Isotope, $);

function getHashFilter() {
  var hash = location.hash;
  // get filter=filterName
  var matches = location.hash.match( /filter=([^&]+)/i );
  var hashFilter = matches && matches[1];
  return hashFilter && decodeURIComponent( hashFilter );
}

var $container, $futureContainer;
$(function () {
    var checkedBodyTypes = [];
    var checkedFuelTypes = [];
    var comboFilters = "";
    $container = $("#vehicle-listing");
    $container.addClass("vehicles-loaded");

    $container.isotope({
        sortAscending: {
            bodyStyleOrFuelType: false,
            bodyStyleAndFuelType: false,
            title: true,
        },
        getSortData: {
            title: ".vehicles-listing__vehicle-title",
            bodyStyleOrFuelType: function (itemElem) {
                var activeClass = comboFilters.split(",");
                var numMatchedClass = 0;
                for (var i = 0; i < activeClass.length; i++) {
                    if ($(itemElem).hasClass(activeClass[i].substring(1))) {
                        numMatchedClass++;
                    }
                }
                return numMatchedClass;
            },
            bodyStyleAndFuelType: function (itemElem) {
                var numMatchedClass = 0;
                for (var i = 0; i < checkedBodyTypes.length; i++) {
                    if (
                        $(itemElem).hasClass(checkedBodyTypes[i].substring(1))
                    ) {
                        numMatchedClass++;
                    }
                }
                for (var i = 0; i < checkedFuelTypes.length; i++) {
                    if (
                        $(itemElem).hasClass(checkedFuelTypes[i].substring(1))
                    ) {
                        numMatchedClass++;
                    }
                }
                return numMatchedClass;
            },
        },
    });

    $("#filters").on("change", function (jQEvent) {
        //get all checked checkboxes
        var urlParams = '?';
        checkedBodyTypes = $("#filters .body-filters :checkbox:checked")
            .map(function (i, ele) {
                return $(ele).val();
            })
            .get();
        if( checkedBodyTypes.length ) {
            urlParams += 'body='+encodeURIComponent(checkedBodyTypes)+'&';
        }
        checkedFuelTypes = $("#filters .fuel-filters :checkbox:checked")
            .map(function (i, ele) {
                return $(ele).val();
            })
            .get();
        if( checkedFuelTypes.length ) {
            urlParams += 'fuel_type='+encodeURIComponent(checkedFuelTypes);
        }

        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + urlParams;
        window.history.pushState({ path: newurl }, '', newurl);
        

        if (checkedBodyTypes.length > 0 && checkedFuelTypes.length > 0) {
            $container.hideRevealBoth({
                bodyTypes: checkedBodyTypes,
                fuelTypes: checkedFuelTypes,
            });
            $container.isotope("updateSortData").isotope({
                sortBy: ["bodyStyleAndFuelType", "title"],
            });
        } else {
            if (checkedBodyTypes.length > 0) {
                comboFilters = checkedBodyTypes.join(",");
                $container.hideReveal({
                    filter: comboFilters,
                });
            } else if (checkedFuelTypes.length > 0) {
                comboFilters = checkedFuelTypes.join(",");
                $container.hideReveal({
                    filter: comboFilters,
                });
            } else {
                comboFilters = "";
                $container.hideReveal({
                    filter: "*",
                });
            }
            $container.isotope("updateSortData").isotope({
                sortBy: ["bodyStyleOrFuelType", "title"],
            });
        }
    }).trigger('change');

    $("#reset").on("click", function () {
        // reset filters
        $container.hideReveal({
            filter: "*",
        });
        // reset checkboxes
        $("#filters input").prop("checked", false); // Unchecks it
        $("#filters").trigger('change');

        $container.isotope("updateSortData").isotope({
            sortBy: ["title"],
        });
    });

    $futureContainer = $("#future-vehicle-listing");
    $futureContainer.addClass("vehicles-loaded");
    $futureContainer.isotope();
});

$.fn.hideReveal = function (options) {
    options = $.extend({
            filter: "*",
            hiddenStyle: {
                opacity: 0.2,
            },
            visibleStyle: {
                opacity: 1,
            },
        },
        options
    );
    this.each(function () {
        var $items = $(this).children();
        var $visible = $items.filter(options.filter);
        var $hidden = $items.not(options.filter);
        // reveal visible
        $visible.animate(options.visibleStyle);
        // hide hidden
        $hidden.animate(options.hiddenStyle);
    });
};

$.fn.hideRevealBoth = function (options) {
    options = $.extend({
            bodyTypes: [],
            fuelTypes: [],
            hiddenStyle: {
                opacity: 0.2,
            },
            visibleStyle: {
                opacity: 1,
            },
        },
        options
    );
    this.each(function () {
        var $items = $(this).children();
        var $bodyTypeVisible = $items.filter(options.bodyTypes.join(","));
        var $fuelTypeVisible = $items.filter(options.fuelTypes.join(","));
        var $bodyTypehidden = $items.not(options.bodyTypes.join(","));
        var $fuelTypehidden = $items.not(options.fuelTypes.join(","));
        // reveal visible
        $bodyTypeVisible.animate(options.visibleStyle);
        $fuelTypeVisible.animate(options.visibleStyle);
        // hide hidden
        $bodyTypehidden.animate(options.hiddenStyle);
        $fuelTypehidden.animate(options.hiddenStyle);
    });
};
const initVideoCarousel = () => {
    $(".intro-content__video-carousel-videos").each(function (idx, elem) {
        let wrapAround = false,
            arrows = false;
        // count videos, if exactly 3, duplicate them so wrapAround works properly
        if ($(elem).find(".video-component").length == 3) {
            let markup = $(elem).html();
            $(elem).html(markup + markup);
        }

        if ($(elem).find(".video-component").length > 3) {
            wrapAround = true;
        }
        if ($(elem).find(".video-component").length > 1) {
            arrows = true;
        }

        var $carousel;
        $carousel = $(elem).flickity({
            initialIndex: 0,
            imagesLoaded: true,
            setGallerySize: false,
            wrapAround: wrapAround,
            cellPosition: "center",
            prevNextButtons: arrows,
            dragThreshold: 3,
            selectedAttraction: 0.2,
            friction: 0.8,
        });
        var flkty = $carousel.data("flickity");

        $carousel.on("staticClick.flickity", function (
            event,
            pointer,
            cellElement,
            cellIndex
        ) {

            // dismiss if cell was not clicked
            if (!cellElement) {
                return;
            }

            // if we click the selected item, then show modal
            if (cellIndex == flkty.selectedIndex) {

                $(cellElement)
                    .find(".modal-link")
                    .trigger("click");

                // otherwise go to the selected item
            } else {
                $carousel.flickity("select", cellIndex);
            }
        });
    });

    // attach modal event to regular video component
    $(".video-component").each(function (idx, elem) {
        $(elem)
            .find(".modal-link")
            .on("touchstart click", function (e) {
                e.preventDefault();
                var $content = $(elem).find(".video-component__video");
                $.featherlight($content, {
                    variant: "video-component__modal",
                    closeOnClick: false,
                });

                let videoTitle = $(elem).find('.video-component__headline').text(),
                    videoType = $(elem).parent().hasClass('flickity-slider') ? 'carousel' : 'standalone';

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'video_title': videoTitle,
                    'video_type': videoType,
                    'event': 'open_lightbox_video'
                });
            });
    });
};

function initAttractionsListing() {
    $('.community-attractions-listing__clear-fitlers').on('click', function () {
        FWP.reset('attraction_types');
    })
}


function wrapFormSelects() {
    $('#mc_embed_signup_scroll select').each(function () {
        $(this).wrap('<div class="select-wrapper">')
    })
}

function wrapTables() {
    $('table').each(function() {
        $(this).wrap('<div class="table-wrapper">');
    })
}

function initCarousel() {
    $('.carousel').each(function () {
        let _this = $(this);
        let $items = _this.find('.carousel__items');
        $items.on('ready.flickity', function () {
            toggleImageSlideClass(_this, 0);
        })
        $items.flickity({
            pageDots: false,
            adaptiveHeight: true,
        });
        let $nav = _this.find('.carousel__nav').flickity({
            contain: true,
            cellAlign: 'left',
            asNavFor: '.carousel__items',
            pageDots: false,
            prevNextButtons: false,
        });

        $items.on('change.flickity', function (event, index) {
            toggleImageSlideClass(_this, index);
        })

        function toggleImageSlideClass(ele, index) {
            let activeSlide = ele.find('.carousel__item')[index];
            if ($(activeSlide).hasClass('carousel__item--with-image')) {
                ele.find('.carousel__items').addClass('current-slide-has-image');
            } else {
                ele.find('.carousel__items').removeClass('current-slide-has-image');
            }
        }
    });
}

function vehicleListingCarousel() {
    var carousel = $('.vehicle-listing');
    carousel.each(function() {
        let _this = $(this);

        // Watch if cards have loaded
        const observer = new MutationObserver((mutations, obs) => {
            const cards = _this.find('.card');

            // once cards have loaded init flickity
            if (cards.length > 0) {
                var $carousel = _this.find('.carousel--flickity').flickity({
                    pageDots: false,
                    cellAlign: 'left',
                    wrapAround: true,
                });
                $carousel.flickity('resize');
                $carousel.flickity('reposition');
                cards.matchHeight({
                    byRow: true,
                });
                obs.disconnect();
                return;
            }
        });
        
        observer.observe(_this[0], {
            childList: true,
            subtree: true
        });        
    })
}
